import { useState } from "react";
import { useNavigate } from "react-router-dom";
import SubscriptionNavigation from "./SubscriptionNavigation";

const SubscriptionSteamer = () => {
  const cupsPerDayList = [
    { id: "1", title: "Once a day" },
    { id: "2", title: "Twice a day" },
    { id: "3", title: "3x a day" },
    { id: "4", title: "4x a day" },
    { id: "5", title: "5x a day" },
    { id: "6", title: "6x a day" },
    { id: "7", title: "7x a day" },
    { id: "8", title: "8x a day" },
    { id: "9", title: "9x a day" },
    { id: "10", title: "10x a day" },
    { id: "0", title: "I never use the frother/steamer" },
  ];

  const [cupsADay] = useState(localStorage.getItem("subscriptionCupsADay"));
  const [steamer, setSteamer] = useState(
    localStorage.getItem("subscriptionSteamer")
  );
  const navigate = useNavigate();

  if (!cupsADay) {
    navigate("/subscription/cups-per-day");
  }

  const handleFormSubmission = (e) => {
    e.preventDefault();
    localStorage.setItem("subscriptionSteamer", steamer);
    navigate("/subscription/subscription-options");
  };

  return (
    <div className="container">
      <div className="col-6 mx-auto">
        <h2>Frother/steamer usage</h2>

        <form onSubmit={handleFormSubmission}>
          <div>
            <div className="mb-3">
              <p>
                How many times do you use the frother/steamer on your coffee
                machines?
              </p>
              {cupsPerDayList.map((item) => (
                <div key={item.id} className="form-check">
                  <input
                    name="steamer"
                    id={`steamer-${item.id}`}
                    className="form-check-input"
                    type="radio"
                    value={item.id}
                    checked={item.id === steamer}
                    onChange={(e) => {
                      setSteamer(e.target.value);
                    }}
                  />
                  <label
                    className="form-check-label"
                    htmlFor={`steamer-${item.id}`}
                  >
                    {item.title}
                  </label>
                </div>
              ))}
            </div>
          </div>

          <SubscriptionNavigation
            buttonBackUrl="/subscription/cups-per-day"
            buttonNextEnabled={steamer}
          />
        </form>
      </div>
    </div>
  );
};

export default SubscriptionSteamer;
